"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_constants_1 = require("../form-constants");
var form_input_element_base_1 = require("./form-input-element-base");
var _1 = require(".");
var requiredDefinitions = require("./required-definition");
var dataFormats = require("./data-format");
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.group, subElementsList: immutable_1.List([]), groupType: form_constants_1.groupTypes.INDENTED, immutableRequiredDefinition: null, immutableDataFormat: null });
/** Factory that generates Immutable [[IGroupElementRecord]] */
exports.GroupElementRecord = immutable_1.Record(exports.defaultValues);
/** class used to represent an immutable version of the [[GroupElement]] */
var ImmutableGroupElement = /** @class */ (function (_super) {
    __extends(ImmutableGroupElement, _super);
    /** constructs an immutable group element from the standard JS Object [[GroupElement]] */
    function ImmutableGroupElement(props) {
        var _this = _super.call(this, __assign({}, props, { subElementsList: immutable_1.List(props.subElements.map(function (element) { return _1.convertToImmutable(element); })), immutableRequiredDefinition: requiredDefinitions.convertToImmutable(props.requiredDefinition), immutableDataFormat: dataFormats.convertToImmutable(props.dataFormat) })) || this;
        _this.subElements = _this.subElementsList.toArray();
        _this.requiredDefinition = props.requiredDefinition;
        _this.dataFormat = props.dataFormat;
        return _this;
    }
    /**
     * creates a clone of the current ImmutableGroupElement
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableGroupElement.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableGroupElement(object);
    };
    /** makes sure that converting this to an object includes the subElements array */
    ImmutableGroupElement.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        var immutableSubElements = object.subElementsList.toArray();
        object.subElements = immutableSubElements.map(function (element) { return element.toObject(); });
        object.requiredDefinition = object.immutableRequiredDefinition && object.immutableRequiredDefinition.toObject();
        object.dataFormat = object.immutableDataFormat && object.immutableDataFormat.toObject();
        return object;
    };
    return ImmutableGroupElement;
}(exports.GroupElementRecord));
exports.ImmutableGroupElement = ImmutableGroupElement;
//# sourceMappingURL=group-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/group-element.js
// module id = 1131
// module chunks = 0